/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/jsx-no-comment-textnodes */
import { transform } from 'lodash'
import React, { useState, useEffect} from 'react'

const GoogleZoom = (props) => {
    const [ backgroundX, setBackgroundX ] = useState(0)

    // initial class for the zoom
    let classForZoom = {
        backgoundColor: 'black',
        zoom: backgroundX,
        maxWidth: `90vw`,
        maxHeight: `90vh`,
        backgoundSize: 'cover',
        backgroundPosition: 'center',
    }

    // function for changing the zoom
    const handleZoom = (e, theValue) => {
        if (theValue === 'plusx') {
            let currentX = backgroundX+1
            setBackgroundX(currentX)
        } else if (theValue === 'minusx') {
            let currentX = backgroundX-1
            setBackgroundX(currentX)
        }
    }

    return (
        <>
            <div className='imageContainerGoogleZoom'>
                <div className='labelForCoordX'>Zoom</div>
                <div className='zoomButtonsContainer'>
                    <div className='plusZoom' name='plus' onClick={(e, theValue) => handleZoom(e, 'plusx')}>
                        +
                    </div>
                    <div className='lineSeperator'>

                    </div>
                    <div className='minusZoom' name='minus' onClick={(e, theValue) => handleZoom(e, 'minusx')}> 
                        -
                    </div>
                </div>
                <img 
                    src={props.img} 
                    alt="Loaded image does not render"
                    style={classForZoom}
                    id='someImageScrollStyle'
                />
            </div>
        </>
    )
}

export default GoogleZoom